import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ListItem.scss';
import MerchantEnabledCheckbox from '../MerchantEnabledCheckbox';

export default class ListItem extends Component {
    static propTypes = {
        item: PropTypes.any.isRequired
    };

    static defaultProps = {
        item: {}
    };

    render() {
        const merchant = this.props.item;

        return (
            <div className="merchant-list-item">
                <div className="list-item-left">
                    <span className="merchant-name">{merchant.name}</span>
                    <span className="merchant-id">{merchant.merchantId}</span>
                </div>
                <div className="list-item-right">
                    Enabled: <MerchantEnabledCheckbox checked={merchant.enabled} merchantId={merchant.merchantId} />
                </div>
            </div>
        );
    }
}
